import React, { Component } from 'react';
import { config } from '../Constants';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

export default class Register extends Component {

    constructor(props) {
        super(props);

        this.state = {
            add_id_card: '',
            add_first_name: '',
            add_last_name: '',
            add_age: 0,
            add_phone: '',
            add_line_id: '',
            add_email: '',
            add_project: '',
            add_house_number: '',
            add_plot: '',
            add_address: '',
            add_moo: '',
            add_road: '',
            add_county: '',
            add_province: '',
            add_zip_code: '',
            add_user_type: '',
            registerIsOpen: false,
            successIsOpen: false,
        }

        this.clearData = this.clearData.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.closeRegister = this.closeRegister.bind(this);
        this.openRegister = this.openRegister.bind(this);
        this.change = this.change.bind(this);
        this.closeSuccess = this.closeSuccess.bind(this);
        this.openSuccess = this.openSuccess.bind(this);

    }

    clearData(e) {
        /*add_id_card
            add_first_name
            add_last_name
            add_age
            add_phone
            add_line_id
            add_email
            add_project
            add_house_number
            add_plot
            add_address
            add_moo
            add_road
            add_county
            add_province
            add_zip_code
            add_user_type*/

            this.setState({ 
                add_id_card: '',
                add_first_name: '',
                add_last_name: '',
                add_age: 0,
                add_phone: '',
                add_line_id: '',
                add_email: '',
                add_project: '',
                add_house_number: '',
                add_plot: '',
                add_address: '',
                add_moo: '',
                add_road: '',
                add_county: '',
                add_province: '',
                add_zip_code: '',
                add_user_type: '',
            });
            document.getElementById("data-form").reset();
    }

    submitRegister(e){
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_card: this.state.add_id_card,
                    first_name: this.state.add_first_name,
                    last_name: this.state.add_last_name,
                    age: this.state.add_age,
                    phone: [{ phone: this.state.add_phone }],
                    line_id: this.state.add_line_id,
                    email: [{ email: this.state.add_email }],
                    project_home_id: this.state.add_project,
                    house_number: this.state.add_house_number,
                    plot: this.state.add_plot,
                    address: this.state.add_address,
                    moo: this.state.add_moo,
                    road: this.state.add_road,
                    county: this.state.add_county,
                    province: this.state.add_province,
                    zip_code: this.state.add_zip_code,
                    user_type: [{ user_type: this.state.add_user_type }],
                    active_status: 0,
                }),
                
            };
    
            fetch(config.url.API_URL + '/memberswaiting', requestOptions)
                .then(res => res.json())
                .then(data => {
                    
                    this.setState({
                        registerIsOpen: false,
                        successIsOpen: true,
                    });
    
                    this.clearData();
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openRegister(e){
        if(this.state.add_id_card == ""){
            alert("ไม่พบข้อมูลบัตรประชาชน");
            return;
        }

        if(this.state.add_first_name == "" || this.state.add_last_name == ""){
            alert("ไม่พบข้อมูลชื่อหรือนามสกุล");
            return;
        }

        if(this.state.add_age == ""){
            alert("ไม่พบข้อมูลอายุ");
            return;
        }

        if(this.state.add_phone == ""){
            alert("ไม่พบข้อมูลเบอร์โทรศัพท์");
            return;
        }

        if(this.state.add_project == ""){
            alert("ไม่พบข้อมูลโครงการบ้าน");
            return;
        }
        if(this.state.add_user_type == ""){
            alert("ไม่พบข้อมูลประเภทสมาชิก");
            return;
        }
        
        this.setState({ 
            registerIsOpen: true,
        });
    }

    closeRegister(e){
        this.setState({ 
            registerIsOpen: false,
            add_id_card: '',
            add_first_name: '',
            add_last_name: '',
            add_age: 0,
            add_phone: '',
            add_line_id: '',
            add_email: '',
            add_project: '',
            add_house_number: '',
            add_plot: '',
            add_address: '',
            add_moo: '',
            add_road: '',
            add_county: '',
            add_province: '',
            add_zip_code: '',
            add_user_type: '',
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    
    closeSuccess(e){
        this.setState({ 
            successIsOpen: false,
        });
    }

    openSuccess(e){
        this.setState({ 
            successIsOpen: true,
        });
    }

    render() {
        return (<div id="wrapper">
                    <div className="nav-overlay" />
                    <header className>
                        <div className="row align-justify">
                        <a href="https://www.nirvanadaii.com/th" className="home-logo">
                            <img src="/img/logo.png" alt="Nirvana Daii" className="logo" />
                        </a>
                        </div>
                    </header>
                    <main>
                        <div id="form_container">
                        <header>
                            <h1>Register Old Member</h1>
                        </header>
                        <div className="row">
                            <div className="col-sm-6">
                            <img src="/img/main-elegance-gate-entrance.jpg" alt="image register" className="image_register"/>
                            </div>
                            <div className="col-sm-6 form-register">
                                <form id="data-form">
                                <div className="row">
                                    <div className="col-sm-12 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="เลขบัตรประชาชน" deault id="add_id_card" name="add_id_card"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="ชื่อ" id="add_first_name" name="add_first_name"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="นามสกุล" id="add_last_name" name="add_last_name"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} type="number" placeholder="อายุ" id="add_age" name="add_age"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="เบอร์โทรศัพท์" id="add_phone" name="add_phone"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" type="email" onChange={this.change} placeholder="อีเมล" id="add_email" name="add_email"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="LINE ID" id="add_line_id" name="add_line_id"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 mt-2">
                                        <select className="form-control" id="add_project" name="add_project" onChange={this.change} >
                                            <option value="">เลือกโครงการ</option>
                                            <option value="5e639ca06489ff64fc1eb037">ไม่ระบุโครงการ</option>
                                            <option value="5e7058aa170a1a78ea0cb431">กินซ่า</option>
                                            <option value="5e7058ed170a1a78ea0cb4cd">ดีจิ</option>
                                            <option value="5e2309a1cf246969fdc771e3">บันยันทรี เรสสิเดนซ์ ริเวอร์ไซด์ กรุงเทพ</option>
                                            <option value="5e2308f2cf246969fdc771e2">เนอวานา สาทร เฟส 1-3</option>
                                            <option value="5e2308b9cf246969fdc771e1">เนอวานา พาร์ค สุขุมวิท 77</option>
                                            <option value="5e23086bcf246969fdc771e0">เนอวานา สุวรรณภูมิ</option>
                                            <option value="5e2307f5cf246969fdc771df">เนอวานา โชคชัย 4</option>
                                            <option value="5e230732cf246969fdc771de">เนอวานา อินโทร</option>
                                            <option value="5e2306cccf246969fdc771dd">เนอวานา รามคำแหง 53</option>
                                            <option value="5e23067dcf246969fdc771dc">เนอวานา ไอคอน พระราม9</option>
                                            <option value="5e2305f2cf246969fdc771db">เนอวานา ไอคอน วงแหวน - พระราม 9</option>
                                            <option value="5e2302e9cf246969fdc771d3">เดอะ โมส อิสรภาพ</option>
                                            <option value="5e230282cf246969fdc771d2">เดอะ ธารา บาย เนอวานา รามอินทรา</option>
                                            <option value="5e2301d2cf246969fdc771d1">เนอวานา ไอคอน ปิ่นเกล้า</option>
                                            <option value="5e2300d5cf246969fdc771d0">เนอวานา บียอนด์ ไลท์</option>
                                            <option value="5e230060cf246969fdc771cf">เนอวานา บียอนด์ พระราม9</option>
                                            <option value="5e22ff0dcf246969fdc771ce">เนอวานา บียอนด์ รามคำแหง</option>
                                            <option value="5e22fe93cf246969fdc771cd">เนอวานา บียอนด์ เกษตร - นวมินทร์</option>
                                            <option value="5e22fe02cf246969fdc771cc">เนอวานา บียอนด์ แอทบีช พัทยา</option>
                                            <option value="5e22fd5ecf246969fdc771cb">เนอวานา บียอนด์ ศรีนครินทร์</option>
                                            <option value="5e22fc22cf246969fdc771ca">เนอวานา บียอนด์ พระราม 2</option>
                                            <option value="5e22fb1ecf246969fdc771c9">เนอวานา บียอนด์ อุดรธานี</option>
                                            <option value="5e22fab0cf246969fdc771c8">เนอวานา บียอนด์ กรุงเทพกรีฑา - พระราม 9</option>
                                            <option value="5e22f988cf246969fdc771c6">คัฟเวอร์ บาย เนอวานา</option>
                                            <option value="5e22f8dccf246969fdc771c4">คลัสเตอร์ บาย เนอวานา</option>
                                            <option value="5e22f814cf246969fdc771c3">เนอวานา ดีฟายน์ ศรีนครินทร์ - พระราม 9</option>
                                            <option value="5e22f6c8cf246969fdc771c2">เนอวานา ดีฟายน์ พระราม 9</option>
                                            <option value="5e22d5629130f54c51794ef9">ช็อป แอนด์ ชิลล์ บาย เนอวานา รามคำแหง</option>
                                            <option value="5e22d49e9130f54c51794ef8">เนอวานา @Work รามอินทรา</option>
                                            <option value="5e22d3b29130f54c51794ef7">เนอวานา @Work พระราม 9 - รามคำแหง</option>
                                            <option value="5e22d2f79130f54c51794ef6">เนอวานา @Work ลาดพร้าว - เกษตรนวมินทร์</option>
                                            <option value="5e22c7339130f54c51794ef5">เนอวานา @Work เกษตรนวมินทร์</option>
                                            <option value="5e84a07c170a1a78ea3a58a6">เนอวานา สำหรับเทส</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" type="text" onChange={this.change} placeholder="บ้านเลขที่" id="add_house_number" name="add_house_number"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="แปลน" id="add_plot" name="add_plot"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="ที่อยู่" id="add_address" name="add_address"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" type="text" onChange={this.change} placeholder="หมู่" id="add_moo" name="add_moo"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="ถนน" id="add_road" name="add_road"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} type="text" placeholder="แขวง" id="add_moo" name="add_moo"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="เขต" id="add_county" name="add_county"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} type="text" placeholder="จังหวัด" id="add_province" name="add_province"/>
                                    </div>
                                    <div className="col-sm-6 mt-2">
                                        <input className="form-control" onChange={this.change} placeholder="รหัสไปรษณีย์" id="add_zip_code" name="add_zip_code"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 mt-2">
                                        <select className="form-control" onChange={this.change} id="add_user_type" name="add_user_type">
                                            <option value="">เลือกประเภทผู้ใช้</option>
                                            <option value="owner">เจ้าของบ้าน</option>
                                            <option value="install">ผ่อนดาวน์</option>
                                        </select>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6 mt-5 text-center" >
                                <button className="btn" type="reset" id="btn-clear" onClick={this.clearData}>เคลียร์ข้อมูล</button>
                            </div>
                            <div className="col-sm-6 mt-5 text-center">
                                <button className="btn" id="btn-register" onClick={this.openRegister}>ลงทะเบียน</button>
                            </div>
                        </div>
                        </div>
                    </main>
                    <footer className="footer-register">
                        <div id="footer-info">
                        <div className="row align-middle">
                            <div className="col-sm-10 columns info__items">
                            <a href="https://www.nirvanadaii.com/th">
                                <img src="/img/logo.png" alt="logo nirvana daii" />
                            </a>
                            </div>
                            <div className="col-sm-2 columns info__items">
                            <a href="tel:1787">
                                <img src="/img/icon-footer.png" alt={1787} />
                            </a>
                            </div>
                        </div>
                        </div>
                    </footer>
                    <Modal show={this.state.registerIsOpen} onHide={this.closeRegister} size="s">
                        <ModalHeader>
                            <ModalTitle>แจ้งเตือน</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            คุณต้องการยืนยันการลงทะเบียนครั้งนี้ใช่หรือไม่
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" onClick={this.closeRegister}>ยกเลิก</button>&nbsp;&nbsp;
                            <button className="btn btn-success" onClick={this.submitRegister}>ยืนยัน</button>
                        </ModalFooter>
                    </Modal>
                    <Modal show={this.state.successIsOpen} onHide={this.closeSuccess} size="s">
                        <ModalHeader>
                            <ModalTitle>ผลการลงทะเบียนรายการ</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            คุณทำการลงทะเบียนเรียบร้อยแล้ว รอการยืนยันจากเจ้าหน้าที่ ขอบคุณค่ะ
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-success" onClick={this.closeSuccess}>ตกลง</button>&nbsp;&nbsp;
                        </ModalFooter>
                    </Modal>
                    </div>)
    }
}